import { Accordion, AccordionDetails, AccordionSummary, IconButton, List, ListItem, Paper, Tooltip, Typography } from "@mui/material"
import { SyntheticEvent } from "react";
import { BruksklasseType, RoadFeatureRequest, RoadFeatureRequestWithBruksklasse, RoadFeatureType, RoadFeatureTypesWithBruksklasse, SourceReferenceSystem } from "../../../services/RuteplanAPI";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useRouteResponse, useSelectedRouteIndex } from "../../../stores/RouteStore";
import { useRouteSettings } from "../../../stores/RouteSettingsStore";
import { useUserNotificationActions } from "../../../stores/UserNotificationStore";
import UserNotification from "../../common/UserNotification/UserNotification";
import RoadFeatureApiViewButton from "../../Map/RoadFeaturesApiTool/RoadFeatureApiViewButton";


export function RoadFeaturesAPIView() {

    return (
        <Accordion  variant="elevation" > 
            <AccordionSummary expandIcon={<ArrowDropDownIcon/>} style={{paddingLeft: "0px", paddingRight: "0px"}}>
                <Typography>RoadFeatures API requests</Typography>            
            </AccordionSummary>
            <AccordionDetails>
                <Paper style={{paddingLeft: "0px"}} elevation={0}>
                    <RoadFeatureApiViewButton />

                </Paper>
                <Paper style={{paddingLeft: "0px"}} elevation={0}>
                    <RoadFeaturesApiRequests/>
                </Paper>
            </AccordionDetails>            
        </Accordion>
    )
}

function RoadFeaturesApiRequests() {

    const selectedRouteIndex = useSelectedRouteIndex();
    const routeResponse = useRouteResponse();
    const routeSettings = useRouteSettings();
    const notifications = useUserNotificationActions();

    const roadFeatureRequest:RoadFeatureRequest = {
        nvdbReferenceLinks: routeResponse?.routes[selectedRouteIndex].nvdbReferenceLinks!,
        "outputSRS" : SourceReferenceSystem.EPSG_4326,
        "roadFeatureTypes" : Array.from(Object.values(RoadFeatureType))
    }

    const roadFeatureWithBruksklasseRequest:RoadFeatureRequestWithBruksklasse = {
        nvdbReferenceLinks: routeResponse?.routes[selectedRouteIndex].nvdbReferenceLinks!,
        "outputSRS" : SourceReferenceSystem.EPSG_4326,
        "roadFeatureTypes" : Array.from(Object.values(RoadFeatureTypesWithBruksklasse)),
        "bruksklasseType": routeSettings.routeType as BruksklasseType
    }
    
    const copyRoadFeatureRequestToClipBoard = (event: SyntheticEvent, request: RoadFeatureRequest | RoadFeatureRequestWithBruksklasse) => {
        event.stopPropagation();
        navigator.clipboard.writeText( JSON.stringify(request, null, 4)).then( () => {
            notifications.setFeedbackMessage({message: "request copied to clipboard", severity: "success"});
        });
    }

    return (        
        <List>            
            <ListItem style={{paddingLeft: "0px"}}>
                <Tooltip title="Copy request to clipboard" >                   
                    <IconButton onClick={(event) => copyRoadFeatureRequestToClipBoard(event, roadFeatureRequest)}>
                        <ContentCopyIcon fontSize="small"/>
                    </IconButton>                    
                </Tooltip>
                <Typography 
                    fontSize={14} 
                    fontWeight={"bold"} 
                    style={{cursor: "pointer"}} 
                    onClick={(event) => copyRoadFeatureRequestToClipBoard(event, roadFeatureRequest)}>
                        RoadFeatures
                </Typography>                                                    
            </ListItem>

            <ListItem style={{paddingLeft: "0px"}}>                
                <Tooltip title="Copy request to clipboard">
                    <IconButton onClick={(event) => copyRoadFeatureRequestToClipBoard(event, roadFeatureWithBruksklasseRequest)}>
                        <ContentCopyIcon fontSize="small"/>
                    </IconButton>                
                </Tooltip>
                <Typography 
                    fontSize={14} 
                    fontWeight={"bold"} 
                    style={{cursor: "pointer"}} 
                    onClick={(event) => copyRoadFeatureRequestToClipBoard(event, roadFeatureWithBruksklasseRequest)}>
                        RoadFeaturesWithBruksklasse
                    </Typography>                
            </ListItem>                      
            <UserNotification/>
        </List>    
    )
}